<template>
    <div class="widget-component">
        <v-row id="specification" class="bg-gray-f1f3f5 mb-10 py-10">
            <v-container class="container-width">
                <v-col>
                    <h2 class="color-primary mb-5">Specification</h2>

                    <v-tabs :vertical="!resMobile" background-color="transparent">
                        <v-tab v-for="(spec, index) in specifications"
                            :key="index">
                            {{ spec.name }}
                        </v-tab>

                        <v-tab-item v-for="(spec, index) in specifications" :key="index">
                            <v-card flat>
                                <v-card-text v-html="spec.description"></v-card-text>
                            </v-card>
                        </v-tab-item>
                    </v-tabs>
                </v-col>
            </v-container>
        </v-row>
    </div>
</template>

<script>
    import { defineComponent, computed } from '@vue/composition-api'
    import isMobile from '../../composables/isMobile';

    export default defineComponent({
        props: {
            specifications: {
                required: true
            }
        },
        setup(props, context) {
            // Utils
            const resMobile = computed(() => {
                return isMobile();
            });

            return {
                resMobile
            }
        },
    })
</script>

<style lang="scss">
    @import '~vuetify/src/styles/styles.sass';

    #specification{
        .v-tabs{
            &-slider-wrapper{
                display: none;
            }

            .v-item-group{
                .v-tab{
                    justify-content: start;
                    font-size: 20px;
                    line-height: 24px;
                    letter-spacing: 0px;
                    text-transform: none;
                    color: #545759;

                    @media #{map-get($display-breakpoints, 'lg-and-up')}{
                        min-width: 250px;
                        font-size: 26px;
                        line-height: 31px;
                    }

                    &:not(.v-tab--active){
                        opacity: 0.7;
                    }

                    &--active{
                        color: #545759;
                        text-decoration: underline;
                    }
                }
            }

            &-items, .v-card, .v-card__text{
                text-align: left;
                font-size: 17px;
                line-height: 20px;
                background: transparent;
            }
        }
    }
</style>
